import { FC, createContext, useContext, useState } from 'react';

export interface AcademicOfferWizardContextState {
  ceAcademicOfferId: number | null;
  setCeAcademicOfferId: (id: number) => void;
}

const contextDefaultValues: AcademicOfferWizardContextState = {
  ceAcademicOfferId: null,
  setCeAcademicOfferId: () => {
    throw new Error(
      'You must implement an AcademicOfferWizardProvider setCeAcademicOfferId handler',
    );
  },
};

export const AcademicOfferWizardContext = createContext<AcademicOfferWizardContextState>(
  contextDefaultValues,
);

export function useAcademicOfferWizard() {
  return useContext(AcademicOfferWizardContext);
}

interface AcademicOfferWizardProviderProps {
  initialOfferId?: number | null;
}

export const AcademicOfferWizardProvider: FC<AcademicOfferWizardProviderProps> = ({
  children,
  initialOfferId = null,
}) => {
  const [ceAcademicOfferId, setCeAcademicOfferId] = useState<number | null>(
    initialOfferId,
  );

  return (
    <AcademicOfferWizardContext.Provider
      value={{ ceAcademicOfferId, setCeAcademicOfferId }}
    >
      {children}
    </AcademicOfferWizardContext.Provider>
  );
};
